<template>
    <div>
        <h1 style="margin-top:50px; font-family: 'VAGRoundednormal', sans-serif;">Página no encontrada</h1>
        <router-link to="/" class="buprin buintro animate__animated animate__bounceIn animate__delay-1s" id="backhome">Regresar al inicio</router-link>
        <img src="../assets/bg/logo-epm.png" alt="" class="logoepm">
    </div>
</template>

<script>
export default {
    name: "PageNotFound"
}
</script>
